export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const PRODUCTION = "production";
export const state = PRODUCTION;
export const VOICE_FILES = "voice_files";
export const LIGHT_BG = "#f0f0f0";
export const SCHEDULED_EVENTS = ["Birthday", "Anniversary"];
export const MEDIA_TYPES = ["IMAGE", "VIDEO", "DOCUMENT"];
export const INPUT_TYPES = [
  "text",
  "number",
  "password",
  "email",
  "search",
  "tel",
  "url",
  "date",
  "datetime-local",
  "month",
  "week",
  "time",
  "color",
];
export const API_ENDPOINT =
  state === PRODUCTION
    ? "https://newapp.smartgrowthai.com"
    : "http://localhost:5001";
export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
export const MESSAGE_TYPES = [
  "text",
  "image",
  "document",
  "video",
  "reply_buttons",
  "interactive_list",
  "interactive_cta_urls",
  "location",
  "location_request_message",
  "endpoint",
];
